var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUx1Step(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 216,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.425 100.792c0 55.1-44.665 99.765-99.764 99.765-31.542 0-59.665-14.638-77.946-37.493-9.792-12.241-16.76-26.838-19.92-42.804L159.155 1.687a99.171 99.171 0 0144.287 16.382c26.536 17.927 43.984 48.289 43.984 82.723z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M260.492 144.78l-48.328-62.054a5.399 5.399 0 00-4.29-2.097h-45.808a5.405 5.405 0 00-4.889 3.052 5.4 5.4 0 00.598 5.733l26.068 33.45c.656.841.768 1.91.3 2.868a2.667 2.667 0 01-2.444 1.526h-80.862l-2.509 2.721h83.371c2.095 0 3.97-1.17 4.89-3.053a5.408 5.408 0 00-.599-5.736l-26.071-33.447a2.67 2.67 0 01-.296-2.867 2.665 2.665 0 012.443-1.527h45.808c.843 0 1.627.381 2.144 1.048l48.327 62.054a2.716 2.716 0 010 3.343l-48.327 62.054a2.698 2.698 0 01-2.144 1.05h-45.808a2.665 2.665 0 01-2.443-1.526 2.67 2.67 0 01.296-2.868l26.071-33.449a5.404 5.404 0 00.599-5.733 5.407 5.407 0 00-4.89-3.053H64.859l-2.508 2.721h119.348c1.064 0 1.978.569 2.444 1.526a2.66 2.66 0 01-.3 2.865l-26.068 33.45a5.404 5.404 0 00-.598 5.735 5.405 5.405 0 004.889 3.053h45.808a5.397 5.397 0 004.29-2.098l48.328-62.053a5.435 5.435 0 000-6.688z",
    fill: "#DD0510"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 38.698C0 15.098 12.603 0 32.253 0 51.9 0 64.505 15.098 64.505 38.698c0 23.538-12.668 38.696-32.252 38.696C12.668 77.394 0 62.234 0 38.698zm44.306.063c0-13.574-4.353-21.206-12.053-21.206-7.763 0-12.054 7.566-12.054 21.143 0 13.574 4.291 21.141 12.054 21.141 7.762 0 12.053-7.504 12.053-21.078zM101.632 1.768v73.683H81.78V18.466H70.857V1.768h30.776z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUx1Step);
export default __webpack_public_path__ + "static/media/ux-1-step.76f8019b0d4e27c0be862407c47df76c.svg";
export { ForwardRef as ReactComponent };